/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetBackgroundCheckRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
